// Module
var code = `<section class="arch-page">

    <header class="arch-header">
        {{#eyebrow}}
        <div class="eyebrow">{{eyebrow}}</div>
        {{/eyebrow}}

        <h1>{{title}}</h1>
        <p class="subhead">{{subhead}}</p>
    </header>

    {{#sections}}
    <article class="arch-section arch-section-{{sectionId}}">


        <div class="section-eyebrow">{{eyebrow}}</div>

        <h2>{{headline}}</h2>

        <div class="section-body">

            <div class="arch-body">{{body}}</div>

        </div>

    </article>
    {{/sections}}

</section>



`;
// Exports
module.exports = code;